import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Button,
  Paper,
  Box,
  CircularProgress,
  Typography,
} from '@material-ui/core';

import Header from '../../components/Header';
import { appointmentActionsTypes } from '../../redux/appointment/actions';
import { useStyles } from './style';

function RapidQueues({ getRapidQueues, rapidQueues, loading, session }) {
  const classes = useStyles();
  const history = useHistory();
  const [patientInQueue, setPatientInQueue] = useState(false);

  const checkPatientInQueue = () => {
    if (rapidQueues) {
      Object.entries(rapidQueues).some(([index, queue]) => {
        return queue.patients.some((patient) => {
          if (patient[2] === session.identity_document) {
            setPatientInQueue(queue.specialty);
            return true;
          }
          return false;
        });
      });
    }
  };

  useEffect(() => {
    let interval;
    const fetchData = () => {
      getRapidQueues();
    };
    fetchData(); // Initial fetch
    interval = setInterval(fetchData, 10000); // Fetch every 10 seconds
    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (rapidQueues) {
      checkPatientInQueue();
    }
  }, [rapidQueues, session]);

  if (!rapidQueues && loading) {
    return (
      <Box display='flex' justifyContent='center' m='20%'>
        <CircularProgress />
      </Box>
    );
  }

  if (patientInQueue) {
    return (
      <>
        <Header />
        <Box
          display='flex'
          justifyContent='center'
          alignItems='center'
          flexDirection='column'
          mt='120px'
        >
          {rapidQueues && (
            <>
              <div>
                <Typography variant='h4' mb={4}>
                  Estás en cola de espera
                </Typography>
              </div>
              <div>
                <Paper className={classes.queuePaper}>
                  <h1>{rapidQueues[patientInQueue].specialty_name}</h1>
                  <p>
                    Pacientes en cola:{' '}
                    <b>{rapidQueues[patientInQueue].patients.length}</b>
                  </p>
                  <p>
                    Tiempo estimado de espera:{' '}
                    <b>
                      {rapidQueues[patientInQueue].patients.length * 15} minutos
                    </b>
                  </p>
                </Paper>
              </div>
            </>
          )}
        </Box>
      </>
    );
  }

  return (
    <>
      <Header />
      <Box mt='100px' mb={4} textAlign='center'>
        <Typography variant='h2' mb={4} mt='150px'>
          Colas de espera para atención inmediata
        </Typography>
      </Box>
      <Box display='flex' justifyContent='center'>
        {rapidQueues &&
          Object.entries(rapidQueues).map(([index, queue]) => (
            <Paper className={classes.queuePaper} key={index}>
              <h1>{queue.specialty_name}</h1>
              <p>
                Pacientes en cola: <b>{queue.patients.length}</b>
              </p>
              <p>
                Tiempo estimado de espera:
                <b> {queue.patients.length * 15} minutos</b>
              </p>
              <Box mt={3}>
                <Button
                  color='primary'
                  variant='contained'
                  fullWidth
                  onClick={() => history.push(`/rapid/form`, { queue: queue })}
                >
                  Entrar
                </Button>
              </Box>
            </Paper>
          ))}
      </Box>
    </>
  );
}

const mapStateToProps = ({ appointments, session }) => {
  return {
    rapidQueues: appointments.rapidQueues,
    loading: appointments.loading,
    session: session,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getRapidQueues: () =>
    dispatch({ type: appointmentActionsTypes.GET_RAPID_QUEUES }),
});

export default connect(mapStateToProps, mapDispatchToProps)(RapidQueues);
